import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import FloatingButton from "../../components/button/floatingButton";
import * as actions from "../../store/actions/actions";
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Container, FormGroup, Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Header from "../../components/Headers/Header";
import * as Roles from "../../store/actions/roles"
import './file.css'
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import * as History from "../../store/actions/historyFunctions"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import ReactTooltip from 'react-tooltip';
import italianFileTranslations from "../../translations/file/file/it.file.json";
import englishFileTranslations from "../../translations/file/file/en.file.json";
import Col from "react-bootstrap/Col";
import {FormControl} from "react-bootstrap";
import NumberFormat from 'react-number-format';
import {
    checkCorporateAccess,
    OPERATION_DOWNLOAD,
    OPERATION_HISTORY,
    OPERATION_REUPLOAD,
    OPERATION_VIEW, PAYDO_ADMIN, PAYDO_MANAGER
} from "../../store/actions/roles";

class File extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianFileTranslations, "it");
    this.props.addTranslationForLanguage(englishFileTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchFile();
    this.props.fetchCorporates()
    this.props.fetchBanks()
    this.props.contiCorrentiFetch()
    this.props.fetchCampaign()
  }

    onContoCorrenteChange = (contoCorrente) => {
        if(contoCorrente !== '')
            this.props.contoCorrenteChange(contoCorrente)
    }

    onCampaignChange = (campaignId) => {
        let ids=''
        if(campaignId !== '')
            ids=campaignId.split(":");
        this.props.campaignChange({idLogo:ids[0],bankId:ids[1]})
    }

    toggleOTPModal = () => {
        this.props.toggleEmptyModal()
    }

    onDownloadClick = (originalFileName, file, bankId) => {
        let splittedFileName = originalFileName.split(".")
        let fileName = splittedFileName[0] + "_error." + splittedFileName[1]
        let header = "attachment; filename=" + fileName
        this.props.download(header, file, bankId)
    }

    onUploadErrorClick = (id, idBank) => {
        this.props.uploadError(id, idBank)
    }

  onPlickClick = (fileid, bankId) => {
    this.props.fetchPlick(fileid,bankId)
  }

    toggleOTPModal = () => {
        this.props.toggleOTPModal()
    }

    toggleUploadModal = () => {
        this.props.cleanUploadModal()
        this.props.toggleUploadModal()
    }

    toggleNegativeModal = () => {
        this.props.toggleNegativeModal()
    }

    togglePositiveModal = () => {
        this.props.togglePositiveModal()
    }

    toggleEmptyUploadModal = () => {
        this.props.toggleEmptyUploadModal()
    }

    toggleFileRowLimitUploadModal = () => {
        this.props.toggleFileRowLimitUploadModal()
    }

    toggleApprovalAvailabilityModal = (file, idBank, status, currentStatus) => {
        this.props.toggleApprovalAvailabilityModal(file, idBank, status, currentStatus)
    }

    onUpdateClick = (file, idBank, status, currentStatus) => {
        let data = {"file": this.props.file, "status": this.props.status, "isOTP": "REQUEST"}
        this.props.update(data, this.props.idBank)
        this.props.updateSelectedFileStatus(this.props.currentStatus)
        this.props.toggleApprovalAvailabilityModal()
    }

    toggleFileErrorUploadModal = (file, idBank) => {
        this.props.cleanUploadModal()
        this.props.toggleFileErrorUploadModal(file, idBank)
    }

    onSubmitApprovalOTP = (file, idBank, status) => {
      let otp = this.props.currentOTP;

        let data = {"otpCode": otp, "file": file, "status": status, approvalStatus: true, "isOTP": "VERIFY"}
        this.props.update(data, idBank)
    }

    onSubmitRefuseOTP = (file,idBank) => {
        let otp=this.props.currentOTP;

        let data = {"otpCode":otp, "file": file, "status": Roles.getRejectedStatus(),approvalStatus:false,"isOTP":"VERIFY"}

        this.props.update(data,idBank)
    }

    checkApproval = (role,status, lastAuthorizedBy,authorizationType) => {
        let approvalResponse='';

      if(lastAuthorizedBy !== undefined || lastAuthorizedBy !== null){
          if(this.props.authenticatedUser === lastAuthorizedBy){

              approvalResponse="hideElement"
          }else{
              approvalResponse=Roles.checkApproval(role,status,authorizationType) === true ? "hideElement" : ""
          }
      }else{
          approvalResponse=Roles.checkApproval(role,status,authorizationType) === true ? "hideElement" : ""
      }
        return approvalResponse;
    }

    submitHandler = (event) => {
        event.preventDefault()
        let data = {fileToUpload: this.props.fileToUpload, senderAccount: this.props.contoCorrente, campaignId:this.props.campaignId,bankId:this.props.bankId}
        this.props.uploadFile(data)
    }

    submitErrorHandler = (event) => {
        event.preventDefault()
        let data = { fileId: this.props.fileId, fileToUpload: this.props.fileToUpload, bankId:this.props.bankId}
        this.props.uploadErrorFile(data)
    }

    getButtons = (status) => {
      if(status==="ERROR"){
          return <i className="fas fa-times text-danger" />
      }
        return <div>
            <i className="fas fa-check text-success" />/<i className="fas fa-times text-danger" />
        </div>
    }

    getUploadErrors = (row,userCorporates,role) => {
        let response=""
        if(row.status==="ERROR") {
            response = role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminFilesAccess(userCorporates,row,Roles.OPERATION_TYPE_WRITE,Roles.OPERATION_REUPLOAD)
                :
            <Button size="sm" onClick={() => this.toggleFileErrorUploadModal(row.id, row.idBank)}>
                <i className="fas fa-upload text-success"/>
            </Button>

            return response
        }
    }

    getDownloadButtons = (row,userCorporates,role) => {
      let response=""
        if(row.status==="ERROR")
            response = role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminFilesAccess(userCorporates,row,Roles.OPERATION_TYPE_READ,Roles.OPERATION_DOWNLOAD)
                :
            <Button size="sm" onClick={()=>this.onDownloadClick(row.originalFileName, row.id, row.idBank)}>
                <i className="fas fa-download text-danger" />
            </Button>

        return response
    }

    checkHistory = (file,bankId) => {
      let data={file:file,bankId:bankId}
      this.props.fetchHistory(data);
    }

    getBankName=(bankId)=>{
      let banks=this.props.banks;
      if(banks !== null || banks !== undefined){
          let bankName=bankId;
          banks.map(bank=>{
              if(bank.bankId===bankId){
                  bankName=bank.bankName;
              }
          })
          return bankName
      }
      return bankId;
    }

    getCorporateName = (corporateId) =>{
        let corporates = this.props.corporates;
        if(corporates !== null || corporates !== undefined) {
            let corporateName = corporateId;
            corporates.map(corporate => {
                if(corporate.corporateSenderId === corporateId) {
                    corporateName = corporate.corporateSenderName;
                }
                return ""
            })
            return corporateName
        }
        return corporates;
    }

    onFileChange = async (event) => {
        let file = event.target.files[0]
        event.preventDefault();
        this.props.fileChange(file)
    }
    checkBankCorporateAdminFilesAccess=(userCorporates,row,opType,op)=>{

        let currentCorporateSenderId=row.corporateSenderId;

        let access=checkCorporateAccess(userCorporates,currentCorporateSenderId,opType)

        if(access===true){
            if(op === OPERATION_VIEW){
                return <Button size="sm" onClick={()=>this.onPlickClick(row.id,row.idBank)} >
                    <i className="ni ni-bullet-list-67 text-purple" />
                </Button>
            }else if(op === OPERATION_DOWNLOAD){
                return <Button size="sm" onClick={()=>this.onDownloadClick(row.originalFileName, row.id, row.idBank)}>
                    <i className="fas fa-download text-danger" />
                </Button>
            }else if(op === OPERATION_REUPLOAD){
                return <Button size="sm" onClick={() => this.toggleFileErrorUploadModal(row.id, row.idBank)}>
                    <i className="fas fa-upload text-success"/>
                </Button>
            }else if(op === OPERATION_HISTORY){
                return <Button size="sm" onClick={()=>this.checkHistory(row.id,row.idBank)} >
                    <i className="ni ni-book-bookmark text-cyan" />
                </Button>
            }

        }else{
            return ""
        }
    }

    render() {
        let role = this.props.role;
        let closedFile = <Translate id="file.closed" />;
        let openFile = <Translate id="file.active" />;
        let approvalResponse=this.props.approvaleResponse;
        let isOTP=false;
        let otpValid=false;
        let header="OTP"
        if(role === Roles.BANK_CORPORATE_AUTHORIZER){
            header=""
        }
        let modalError=""
        let fileId=""
        let fileStatus=""
        let idBank=""
        let errors=""
        errors=this.props.validationError
        let fileToUploadError=""
        let senderAccountError=""
        let campaignError=""
        if(errors !== null && errors !== "" && errors !== undefined){
            if(errors.data.length>0){
                errors.data.map((item) =>{
                    if(item.field ==='fileToUpload'){
                        fileToUploadError=item.defaultMessage;
                    }
                    if(item.field === 'senderAccount'){
                        senderAccountError=item.defaultMessage
                    }
                    if(item.field === 'campaignId'){
                        campaignError=item.defaultMessage
                    }
                    return ""
                })
            }
        }
      if(approvalResponse !== null){
          isOTP=approvalResponse.otp;
          otpValid=approvalResponse.otpValid;
          fileId=approvalResponse.fileId
          fileStatus=approvalResponse.status
          idBank=approvalResponse.idBank

          if(isOTP === false && role !== Roles.BANK_CORPORATE_AUTHORIZER){
              if(otpValid === true){
                  modalError=<Translate id="file.otp.correct" data={{ fileStatus: approvalResponse.status }}/>
              }else{
                  modalError=<Translate id="file.otp.not.correct"/>
              }
          }else if(isOTP === true && role !== Roles.BANK_CORPORATE_AUTHORIZER) {
              modalError=<Translate id="file.otp.request"/>
          }else{
              if(otpValid === true){
                  modalError=<Translate id="file.otp.correct" data={{ fileStatus: approvalResponse.status }}/>
              }else{
                  modalError=<Translate id="file.otp.bank.auth.text"/>
              }

          }
      }

        let approvalAvailabilityModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasApprovalAvailabilityModal}
                   presentationStyle="fullScreen"
                   toggle={this.toggleApprovalAvailabilityModal}>
                <ModalHeader toggle={this.toggleApprovalAvailabilityModal}>
                    <Translate id="file.approvalAvailabilityModal.header"/>
                </ModalHeader>
                <ModalBody>
                    <div className="pl-lg-12">
                        <Row>
                            <Col lg="12">
                                <Translate id="file.approvalAvailabilityModal.body"/>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col>
                            <Button color="danger" onClick={this.toggleApprovalAvailabilityModal}>
                                <Translate id="file.approvalAvailabilityModal.button.close"/>
                            </Button>
                        </Col>
                        <Col>
                            <Button color="primary" onClick={this.onUpdateClick}>
                                <Translate id="file.approvalAvailabilityModal.button.continue"/>
                            </Button>
                        </Col>

                    </Row>
                </ModalFooter>
            </Modal>

        let fileRowLimitModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasFileRowLimitModal}
                   presentationStyle="fullScreen"
                   toggle={this.toggleFileRowLimitUploadModal}>
                <ModalHeader toggle={this.toggleFileRowLimitUploadModal}>
                    <Translate id="upload.file.rowLimit.header" data={{ name: this.props.fileName }} />
                </ModalHeader>
                <ModalBody>
                    <div className="pl-lg-12">
                        <Row>
                            <Col lg="12">
                                <Translate id="upload.file.rowLimit.body" data={{ name: this.props.fileName }} />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col>
                            <Button color="danger" onClick={this.toggleFileRowLimitUploadModal}>
                                <Translate id="file.rowLimit.button.close"/>
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>

        let emptyModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasUploadEmptyModal}
                   presentationStyle="fullScreen"
                   toggle={this.toggleEmptyUploadModal}>
                <ModalHeader toggle={this.toggleEmptyUploadModal}>
                    <Translate id="upload.file.empty.header" data={{ name: this.props.fileName }} />
                </ModalHeader>
                <ModalBody>
                    <div className="pl-lg-12">
                        <Row>
                            <Col lg="12">
                                <Translate id="upload.file.empty.body" data={{ name: this.props.fileName }} />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col>
                            <Button color="danger" onClick={this.toggleEmptyUploadModal}>
                                <Translate id="file.empty.button.close"/>
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>

        let positiveModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasPositiveModal}
                   presentationStyle="fullScreen"
                   toggle={this.togglePositiveModal}>
                <ModalHeader toggle={this.togglePositiveModal}>
                    <Translate id="upload.file.positive.header" data={{ name: this.props.fileName }} />
                </ModalHeader>
                <ModalBody>
                    <div className="pl-lg-12">
                        <Row>
                            <Col lg="12">
                                <Translate id="upload.file.positive.body" data={{ name: this.props.fileName }} />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col>
                            <Button color="primary" onClick={this.togglePositiveModal}>
                                <Translate id="file.positive.button.close"/>
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>

        let negativeModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasNegativeModal}
                   presentationStyle="fullScreen"
                   toggle={this.toggleNegativeModal}>
                <ModalHeader toggle={this.toggleNegativeModal}>
                    <Translate id="upload.file.negative.header"  data={{ name: this.props.fileName }} />
                </ModalHeader>
                <ModalBody>
                    <div className="pl-lg-12">
                        <Row>
                            <Col lg="12">
                                <Translate id="upload.file.negative.body"  data={{ totalErrorNumber: this.props.totalErrorNumber, name: this.props.fileName }} />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col>
                            <Button color="danger" onClick={this.toggleNegativeModal}>
                                <Translate id="file.negative.button.close"/>
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>

        let uploadModal =
                <Modal className="modal-dialog modal-lg"
                       isOpen={this.props.hasUploadModal}
                       presentationStyle="fullScreen"
                       toggle={this.toggleUploadModal}>
                    <form onSubmit={this.submitHandler} encType="multipart/form-data">
                        <ModalHeader toggle={this.toggleUploadModal}><Translate id="file.upload.header" /></ModalHeader>
                        <ModalBody>
                            <div className="pl-lg-12">
                                <Row>
                                    <Col lg="12">
                                        <Alert color="danger">
                                            <Translate id="file.upload.warning"/>
                                        </Alert>
                                        <ul>
                                            <li><Translate id="file.upload.warning.date"/></li>
                                            <li><Translate id="file.upload.warning.conto"/></li>
                                            <li><Translate id="file.upload.warning.contact"/></li>
                                            <li><Translate id="file.upload.warning.telephone"/></li>
                                            <li><Translate id="file.upload.warning.causal"/></li>
                                        </ul>
                                    </Col>
                                </Row>
                                <Row>
                                    <hr
                                        style={{
                                            width: '75%'
                                        }}
                                    />
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="files">
                                                <Translate id="file.upload.file"/>
                                            </label>
                                            <Translate>
                                                {({ translate }) =>
                                                    <Input
                                                        className={ fileToUploadError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                                        ref={this.file}
                                                        // value={this.props.campaignName}
                                                        onChange={this.onFileChange}
                                                        id="fileToUpload"
                                                        placeholder={translate("file.upload.file")}
                                                        required={true}
                                                        type="file" />}
                                            </Translate>
                                        </FormGroup>
                                        { fileToUploadError.length > 0 ? <label style={{color:"red"}}><Translate id={fileToUploadError}/></label> : "" }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="corporate">
                                                <Translate id="file.upload.contoCorrente"/>
                                            </label>
                                            <FormControl as="select"
                                                         className={ senderAccountError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                                         onChange={(newValue) => {
                                                             this.onContoCorrenteChange(newValue.target.value);
                                                         }}
                                                         required={true}
                                            >
                                                <option></option>
                                                {this.props.contiCorrenti.map((item)=>{
                                                    return <option value={item.senderAccount}>{item.contoCorrente}</option>
                                                })}
                                            </FormControl>
                                        </FormGroup>
                                        { senderAccountError.length > 0 ? <label style={{color:"red"}}><Translate id={senderAccountError}/></label> : "" }
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="campaign">
                                                <Translate id="file.upload.campaign"/>
                                            </label>
                                            <FormControl as="select"
                                                         className={ campaignError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                                         onChange={(newValue) => {
                                                             this.onCampaignChange(newValue.target.value);
                                                         }}
                                                         required={true}
                                            >
                                                <option></option>
                                                {this.props.campaigns.map((item)=>{
                                                    return <option value={item.idLogo+":"+item.bankId} disabled={!item.enabled}>{item.campaignName}</option>
                                                })}
                                            </FormControl>
                                        </FormGroup>
                                        { campaignError.length > 0 ? <label style={{color:"red"}}><Translate id={campaignError}/></label> : "" }
                                    </Col>
                                </Row>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Row>
                                <Col>
                                    <Button color="primary" onClick={this.toggleUploadModal}>
                                        <Translate id="file.upload.button.close"/>
                                    </Button>
                                </Col>
                                <Col>
                                    <Button type="submit" className="btn-success" variant="contained" >
                                        <Translate id="file.upload.button.upload"/>
                                    </Button>
                                </Col>
                            </Row>
                        </ModalFooter>
                    </form>
                </Modal>

        let uploadErrorModal =
            <Modal className="modal-dialog modal-lg"
                   isOpen={this.props.hasErrorUploadModal}
                   presentationStyle="fullScreen"
                   toggle={this.toggleFileErrorUploadModal}>
                <form onSubmit={this.submitErrorHandler} encType="multipart/form-data">
                    <ModalHeader toggle={this.toggleFileErrorUploadModal}><Translate id="file.upload.header" /></ModalHeader>
                    <ModalBody>
                        <div className="pl-lg-12">
                            <Row>
                                <Col lg="12">
                                    <Alert color="danger">
                                        <Translate id="file.upload.warning"/>
                                    </Alert>
                                    <ul>
                                        <li><Translate id="file.upload.warning.date"/></li>
                                        <li><Translate id="file.upload.warning.conto"/></li>
                                        <li><Translate id="file.upload.warning.contact"/></li>
                                        <li><Translate id="file.upload.warning.telephone"/></li>
                                        <li><Translate id="file.upload.warning.causal"/></li>
                                    </ul>
                                </Col>
                            </Row>
                            <Row>
                                <hr
                                    style={{
                                        width: '75%'
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="files">
                                            <Translate id="file.upload.file"/>
                                        </label>
                                        <Translate>
                                            {({ translate }) =>
                                                <Input
                                                    className={ fileToUploadError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                                    ref={this.file}
                                                    // value={this.props.campaignName}
                                                    onChange={this.onFileChange}
                                                    id="fileToUpload"
                                                    placeholder={translate("file.upload.file")}
                                                    required={true}
                                                    type="file" />}
                                        </Translate>
                                    </FormGroup>
                                    { fileToUploadError.length > 0 ? <label style={{color:"red"}}><Translate id={fileToUploadError}/></label> : "" }
                                </Col>
                            </Row>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col>
                                <Button color="primary" onClick={this.toggleFileErrorUploadModal}>
                                    <Translate id="file.upload.button.close"/>
                                </Button>
                            </Col>
                            <Col>
                                <Button type="submit" className="btn-success" variant="contained" >
                                    <Translate id="file.upload.button.upload"/>
                                </Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Modal>

        let userCorporates=this.props.userCorporates;

        let downloadButton = ""
        if(Roles.checkRole(role,Roles.MODULE_FILE,Roles.OPERATION_ERROR, this.props.distinte)){
            downloadButton={
                text: <Translate id="file.download"/>,
                align: 'center',
                formatter:(cellContent, row) => this.getDownloadButtons(row,userCorporates,role)
            }
        }

        let uploadErrorButton = ""
        if(Roles.checkRole(role,Roles.MODULE_FILE,Roles.OPERATION_ERROR, this.props.distinte)){
        uploadErrorButton={
            text: <Translate id="file.upload"/>,
            align: 'center',
            formatter:(cellContent, row) => this.getUploadErrors(row,userCorporates,role)
            }
        }

      let approveButton = ""
      if(Roles.checkRole(role,Roles.MODULE_FILE,Roles.OPERATION_APPROVE, this.props.distinte)){
          approveButton={
              text: <Translate id="file.approve"/>,
              formatter:(cellContent, row) => (
                  <Button size="sm"
                          className={this.checkApproval(role,row.status,row.lastAuthorizedBy,row.authorizationType)}
                          onClick={() => this.toggleApprovalAvailabilityModal(row.id, row.idBank, Roles.getStatus(role, row.status), row.status)}>
                      {this.getButtons(row.status)}
                  </Button>
              )
          }
      }
      let plicks = ""
      if(Roles.checkRole(role,Roles.MODULE_FILE,Roles.OPERATION_VIEW, this.props.distinte)){
          plicks={
              text:  <Translate id="file.plicks"/>,

              formatter:(cellContent, row) => (
                  role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminFilesAccess(userCorporates,row,Roles.OPERATION_TYPE_READ,Roles.OPERATION_VIEW)
                      :
                  <Button size="sm" onClick={()=>this.onPlickClick(row.id,row.idBank)} >
                      <i className="ni ni-bullet-list-67 text-purple" />
                  </Button>
              )
          }
      }

        let createButton = ""
        if (Roles.checkRole(role, Roles.MODULE_FILE, Roles.OPERATION_CREATE, this.props.distinte)) {
            createButton = <FloatingButton label="Upload File" onClick={this.toggleUploadModal} color="primary"/>
        }

        const activeFilescolumns = [
            { dataField: 'originalFileName', text: <Translate id="file.name"/>,
                classes:'fixedWidth',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            { row.originalFileName }
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={ row.originalFileName }><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'idBank', text: <Translate id="file.bank"/>,
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                classes:'fixedWidth',
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            {this.getBankName(row.idBank)}
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={this.getBankName(row.idBank)}><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'corporateSenderId', text: <Translate id="file.corporate"/>,
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                classes:'fixedWidth',
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            {this.getCorporateName(row.corporateSenderId)}
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={this.getCorporateName(row.corporateSenderId)}><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'plicksCount', text: <Translate id="file.plicks.count"/>,headerClasses:'button-header-col',
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                }
            },
            { dataField: 'creationDateLong', text: <Translate id="file.creationDate"/>,headerClasses:'button-header-col',
                sort: true,
                classes:'fixedWidth',
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        {this.formatDate(row.creationDateLong)}
                    </div>
                )
            },
            { dataField: 'totalAmount', text: <Translate id="file.total"/>,headerClasses:'button-header-col',
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <NumberFormat value={row.totalAmount}
                                  displayType={'text'}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  suffix={' €'} />
                )
            },
            { dataField: 'status', text: <Translate id="file.status"/>,
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                classes:'fixedWidth',
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            { row.status }
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={ row.status }><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'approved', text: <Translate id="file.approved"/>,headerClasses:'button-header-col',
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className="disabled">
                        <input key={row.id}
                            type="checkbox" checked={ row.approved } disabled />
                    </div>
                )
            },
            { dataField: 'approved', text: <Translate id="file.approved"/>,headerClasses:'button-header-col',
                // align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className="disabled">
                        <input
                            type="checkbox" checked={ row.approved } disabled />
                    </div>
                )
            },
            plicks,
            approveButton,
            downloadButton,
            uploadErrorButton
        ]

        let historyButton = {
            text: <Translate id="file.history"/>,
            formatter:(cellContent, row) => (
                role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminFilesAccess(userCorporates,row,Roles.OPERATION_TYPE_READ,Roles.OPERATION_HISTORY)
                    :
                <Button size="sm" onClick={()=>this.checkHistory(row.id,row.idBank)} >
                    <i className="ni ni-book-bookmark text-cyan" />
                </Button>
            )
        }

        const closedFilescolumns = [
            { dataField: 'originalFileName', text: <Translate id="file.name"/>,
                classes:'fixedWidth',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            { row.originalFileName }
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={ row.originalFileName }><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'idBank', text: <Translate id="file.bank"/>, align: 'center',
                classes:'fixedWidth',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            {this.getBankName(row.idBank)}
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={this.getBankName(row.idBank)}><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            {
                dataField: 'corporateSenderId', text: <Translate id="file.corporate"/>, align: 'center',
                classes:'fixedWidth',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            {this.getCorporateName(row.corporateSenderId)}
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={this.getCorporateName(row.corporateSenderId)}><Translate id="file.showmore"/></span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'sftpDateLong', text: <Translate id="file.sftpDate"/>,headerClasses:'button-header-col',
                sort: true,
                classes:'fixedWidth',
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className={""}>
                        {this.formatDate(row.sftpDateLong)}
                    </div>
                )
            },
            { dataField: 'plicksCount', text: <Translate id="file.plicks.count"/>,
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                align: 'center' },
            { dataField: 'totalAmount', text: <Translate id="file.total"/>,
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                align: 'center',
                formatter: (cellContent, row) => (
                    <NumberFormat value={row.totalAmount}
                                  displayType={'text'}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  suffix={' €'} />
                )
            },
            { dataField: 'status', text: <Translate id="file.status"/>,
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                }},
            { dataField: 'approved', text: <Translate id="file.approved"/>, align: 'center',
                sort: true,
                sortCaret: (order, column) => {
                    if (!order)
                        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
                    else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
                    else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
                    return null;
                },
                formatter: (cellContent, row) => (
                    <div className="disabled">
                        <input
                            type="checkbox" checked={ row.approved } disabled />
                    </div>
                )
            },
            plicks,
            historyButton
        ]

        const rowEvents = {
            scope:"row"
        };

        let activeFiles= History.getActiveFiles(this.props.files)

        const rowClasses = (row, rowIndex) => {
            if(row.correctFile===false){
                return 'validationError slideAni';
            }else{
                return 'slideAni'            }

        };


        const rowStyle = (row, rowIndex) => {
            return { overflowWrap: 'break-word' };
        };

        let activeFilestable = this.props.files === null ? null :
            <BootstrapTable bootstrap4 headerClasses="thead-light" classes="FixedTable wordwrap align-items-center table-flush" keyField='id' data={ activeFiles }
                            columns={ activeFilescolumns } pagination={ paginationFactory() } rowEvents={ rowEvents }
                            rowClasses={rowClasses} rowStyle={rowStyle}
                            // loading={ true }  //only loading is true, react-bootstrap-table will render overlay
                            // overlay={ overlayFactory({ spinner: true, background: 'rgba(192,192,192,1)' }) }
            />

        let clsoedfiles= History.getClosedFiles(this.props.files)
        let closedFilestable = this.props.files === null ? null :
            <BootstrapTable bootstrap4 headerClasses="thead-light" classes="FixedTable align-items-center table-flush" keyField='id' data={ clsoedfiles }
                            columns={ closedFilescolumns } pagination={ paginationFactory() } rowEvents={ rowEvents }
            />

        return (
            <>
                <Header />
                <Container className="mt--5" fluid>
                    <Row id="pippo">
                        <div className="col" style={{paddingBottom:"2%"}}>
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0">
                                              <Translate id="file.title"/>
                                            </h3>
                                        </div>
                                        <div className="col">
                                            <div style={{float:'right'}}>
                                                {createButton}
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <Tabs defaultActiveKey="fileOpen" id="uncontrolled-tab-example">
                                    <Tab eventKey="fileOpen" title={openFile}>
                                        {activeFilestable}
                                    </Tab>
                                    <Tab eventKey="fileClosed" title={closedFile}>
                                        {closedFilestable}
                                    </Tab>
                                </Tabs>
                            </Card>
                        </div>
                    </Row>
                    <div>
                        <Modal isOpen={this.props.hasModal} toggle={this.toggleOTPModal} >
                            <ModalHeader toggle={this.toggleOTPModal}>{header}</ModalHeader>
                            <ModalBody>
                                <div className="pl-lg-4">
                                <Row>
                                    <Col>
                                        <FormGroup>
                                        <label className="form-control-label" htmlFor="approvalOTP">
                                            {modalError}
                                        </label>
                                            <div>
                                        {
                                            (isOTP === true && role !== Roles.BANK_CORPORATE_AUTHORIZER ) ?
                                                <input className="form-control-alternative"
                                                       type="text" id="approvalOTP" onChange={this.onOTPChange}/>
                                             : ""
                                        }</div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                {
                                    isOTP === true ?
                                        <Row>
                                            <Col>
                                                <Button color="danger" onClick={() => { this.onSubmitRefuseOTP(fileId,idBank)}}><Translate id="file.refuse.button" /></Button>
                                            </Col>
                                            {
                                                this.props.selectedFileStatus !== "ERROR" ?
                                                <Col>
                                                    <Button color="primary" onClick={() => { this.onSubmitApprovalOTP(fileId,idBank,fileStatus)}}><Translate id="file.approve.button" /></Button>
                                                </Col>
                                                    : ""
                                            }
                                        </Row>
                                        :
                                        <Button color="primary" onClick={this.toggleOTPModal}><Translate id="file.otp.close.button" /></Button>
                                }

                            </ModalFooter>
                        </Modal>
                        {uploadModal}
                        {positiveModal}
                        {negativeModal}
                        {emptyModal}
                        {uploadErrorModal}
                        {fileRowLimitModal}
                        {approvalAvailabilityModal}
                    </div>
                </Container>
            </>
        );
    }

    onOTPChange = (event) => {
        let otp = event.target.value
        this.props.onOTPChange(otp)
    }

    formatDate = (dateString) => {
        let language = this.props.languages.filter(language => language.active === true)
        let code = language[0].code
        let locale = 'it-IT'
        if (code === 'en')
            locale = 'en-EN'
        let formattedDate;
        if (dateString !== null && dateString !== 'undefined') {
            let date = new Date(dateString)
            formattedDate = new Intl.DateTimeFormat(locale).format(date)
        }
        return formattedDate;
    }
}


const mapStateToProps = state => {
    return {
        languages: state.localize.languages,
        role : state.authentication.authenticatedUser.role,
        authenticatedUser:state.authentication.authenticatedUser.username,
        corporate:state.authentication.authenticatedUser.corporateSenderId,
        files: state.file.files,
        approvaleResponse : state.file.approveResponse,
        hasModal:state.file.hasModal,
        currentOTP:state.file.currentOTP,
        selectedFileStatus: state.file.selectedFileStatus,
        hasUploadModal: state.file.hasUploadModal,
        hasApprovalAvailabilityModal: state.file.hasApprovalAvailabilityModal,
        hasNegativeModal: state.file.hasNegativeModal,
        hasPositiveModal: state.file.hasPositiveModal,
        hasUploadEmptyModal: state.file.hasUploadEmptyModal,
        hasErrorUploadModal: state.file.hasErrorUploadModal,
        hasFileRowLimitModal: state.file.hasFileRowLimitModal,
        totalErrorNumber: state.file.totalErrorNumber,
        fileName: state.file.fileName,
        fileId: state.file.fileId,
        validationError: state.file.error,

        fileToUpload: state.file.fileUpload.fileToUpload,
        contoCorrente: state.file.fileUpload.contoCorrente,
        campaignId: state.file.fileUpload.campaignId,
        bankId: state.file.fileUpload.bankId,

        // validationError: state.upload.error,
        // emptyFile: state.upload.emptyFile,
        userCorporates: state.authentication.authenticatedUser.userCorporates,

        contiCorrenti: state.contoCorrente.contiCorrenti,
        campaigns: state.campaign.campaigns,
        banks: state.bank.banks,
        corporates: state.corporate.corporates,

        file: state.file.file,
        idBank: state.file.idBank,
        status: state.file.status,
        currentStatus: state.file.currentStatus,
        distinte:  state.authentication.authenticatedUser.distinte
    }
}

const mapDispatchToProps = dispatch => {
    return {
        cleanUploadModal: () => dispatch({ type: actions.FILE_UPLOAD_TOGGLE_EMPTY_FILE}),
        update: (file,idBank) => dispatch({ type: actions.APPROVE_FILE_REQUEST, value: {file:file,bankId:idBank }}),
        download: (header, fileId, bankId) => dispatch({ type: actions.DOWNLOAD_ERROR_FILE_REQUEST, value: {header: header, file: fileId, bankId: bankId }}),
        uploadErrorFile: (file) => dispatch({ type: actions.FILE_REUPLOAD_REQUEST, value: file }),
        fetchFile: () => dispatch({ type: actions.FETCH_FILES_REQUEST }),
        fetchPlick: (file,bankId) => dispatch({ type: actions.FETCH_PLICKS_REQUEST, value: {file:file,bankId:bankId,page:0,size:10} }),
        sendFile: (file) => dispatch({ type: actions.SEND_FILE_REQUEST, value: file }),
        toggleOTPModal:() => dispatch({type:actions.TOGGLE_APPROVAL_MODAL}),
        onSubmitApprovalOTP : (file) => dispatch({type: actions.APPROVE_FILE_REQUEST, value: file}),
        onOTPChange : (otp) => dispatch({type: actions.APPROVE_OTP_CHANGE, value: otp}),
        fetchHistory: (file) => dispatch({type: actions.FETCH_FILE_HISTORY_REQUEST, value: file}),
        fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
        fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
        updateSelectedFileStatus: (currentStatus) => dispatch({ type: actions.UPDATE_SELECTED_FILE_STATUS,value:currentStatus }),
        toggleUploadModal:() => dispatch({type:actions.TOGGLE_UPLOAD_MODAL}),
        toggleNegativeModal:() => dispatch({type:actions.TOGGLE_NEGATIVE_UPLOAD_MODAL}),
        togglePositiveModal:() => dispatch({type:actions.TOGGLE_POSITIVE_UPLOAD_MODAL}),
        toggleEmptyUploadModal:() => dispatch({type:actions.TOGGLE_EMPTY_UPLOAD_MODAL}),
        toggleFileErrorUploadModal:(file, idBank) => dispatch({type:actions.TOGGLE_FILE_ERROR_UPLOAD_MODAL, value: {file:file,bankId:idBank }}),
        uploadFile: (file) => dispatch({type: actions.FILE_UPLOAD_REQUEST, value: file}),
        fileChange: (file) => dispatch({type: actions.FILE_UPLOAD_FILE_FILED_CHANGE_REQUEST, value: file}),
        contoCorrenteChange: (contoCorrente) => dispatch({type: actions.FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE_REQUEST,value: contoCorrente}),
        contiCorrentiFetch: () => dispatch({type: actions.FETCH_CONTO_CORRENTE_REQUEST}),
        fetchCampaign: () => dispatch({type: actions.FETCH_CAMPAIGN_REQUEST}),
        toggleEmptyModal: () => dispatch({type: actions.FILE_UPLOAD_TOGGLE_EMPTY_FILE}),
        campaignChange: (campaignId) => dispatch({type: actions.FILE_UPLOAD_CAMPAIGN_FILED_CHANGE_REQUEST,value: campaignId}),
        toggleFileRowLimitUploadModal: () => dispatch({type:actions.TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL}),
        toggleApprovalAvailabilityModal: (file, idBank, status, currentStatus) => dispatch({type: actions.TOGGLE_APPROVAL_AVAILABILITY_MODAL, value: {file, idBank, status, currentStatus}})
    };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(File));